import { render, staticRenderFns } from "./bkManage.vue?vue&type=template&id=c0181eac"
import script from "./bkManage.vue?vue&type=script&lang=js"
export * from "./bkManage.vue?vue&type=script&lang=js"
import style0 from "./bkManage.vue?vue&type=style&index=0&id=c0181eac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports